import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Responsable from '../Entity/Responsable'

/**
* Class ResponsableList
* ResponsableList view component
**/
class ResponsableList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Responsable;

    // Filter list
    const filters = [{
      title: "Nom du responsable",
      type: "text",
      name: "libelleResponsable",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes responsables</h2>
        <GridFilter title="Filtrer les responsables" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Responsables" ref={"grid" + objectClass.name} path="responsables" objectPath="responsables" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + Responsable.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + Responsable.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + Responsable.name];
    grid.clearFilters();
  }

}
export default ResponsableList;



// WEBPACK FOOTER //
// ./src/views/Search/ResponsableList.js